import { render, staticRenderFns } from "./dialog-report-comment-schema-detail.vue?vue&type=template&id=7874ab37&scoped=true"
import script from "./dialog-report-comment-schema-detail.vue?vue&type=script&lang=js"
export * from "./dialog-report-comment-schema-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7874ab37",
  null
  
)

export default component.exports